<ng-container *ngIf="run">
  <div class="wfrd">
    <div
      class="wfrd__header"
      [class.wfrd__header--inline]="inlineHeaderActions"
    >
      <div class="wfrd__meta">
        <div class="wfrd__meta-item">
          <span class="wfrd__label">Last updated:</span>
          <nz-tag class="wfrd__chip">{{
            run.updatedAt | date : 'medium'
          }}</nz-tag>
        </div>
        <div class="wfrd__meta-item" *ngIf="run.reranAt">
          <span class="wfrd__label">Reran at:</span>
          <nz-tag class="wfrd__chip wfrd__chip--blue">
            {{ run.reranAt | date : 'medium' }}
          </nz-tag>
        </div>
      </div>

    <div
      class="wfrd__actions"
      *ngIf="
        showUpdateFromBlueprint ||
        showMarkResolved ||
        showEditWorkflow ||
        showRerun
      "
    >
      <button
        *ngIf="showUpdateFromBlueprint"
        nz-button
        nzType="primary"
        nzSize="small"
        (click)="updateFromBlueprint.emit()"
      >
        <i nz-icon nzType="reload"></i>
        Update From Blueprint
      </button>
      <button
        *ngIf="showMarkResolved"
        nz-button
        nzType="primary"
        nzSize="small"
        nz-popconfirm
        nzPopconfirmTitle="Mark as Resolved?"
        (nzOnConfirm)="markResolved.emit()"
      >
        <i nz-icon nzType="check"></i>
        Mark as Resolved
      </button>
      <button
        *ngIf="showEditWorkflow"
        nz-button
        nzType="primary"
        nzSize="small"
        (click)="editWorkflow.emit()"
      >
        <i nz-icon nzType="edit"></i>
        Edit Workflow
      </button>
      <button
        *ngIf="showRerun"
        nz-button
        nzType="primary"
        nzSize="small"
        [nzLoading]="rerunLoading"
        (click)="rerun.emit()"
      >
        <i nz-icon nzType="reload"></i>
        Rerun
      </button>
      </div>
    </div>

    <!-- Overview -->
    <nz-card class="wfrd__card" [nzTitle]="overviewTitle">
      <ng-template #overviewTitle>
        <div class="wfrd__card-head">
          <i nz-icon nzType="info-circle"></i>
          Workflow Run Overview
        </div>
      </ng-template>

      <div class="wfrd__grid">
        <div class="wfrd__field">
          <span class="wfrd__label">Run ID:</span>
          <nz-tag class="wfrd__chip wfrd__chip--mono">{{ run._id }}</nz-tag>
        </div>
        <div class="wfrd__field">
          <span class="wfrd__label">Status:</span>
          <nz-tag [nzColor]="statuses?.[run.status]?.color" class="wfrd__chip">
            <i nz-icon [nzType]="iconMap[run.status]"></i>
            {{ run.status | uppercase }}
          </nz-tag>
        </div>
        <div class="wfrd__field">
          <span class="wfrd__label">Trigger Event:</span>
          <nz-tag class="wfrd__chip wfrd__chip--blue">
            {{ run.triggerEvent }}
          </nz-tag>
        </div>
        <div class="wfrd__field" *ngIf="run.createdAt">
          <span class="wfrd__label">Created:</span>
          <span>{{ run.createdAt | date : 'medium' }}</span>
        </div>
      </div>
    </nz-card>

    <!-- Error -->
    <nz-card
      *ngIf="run.error"
      class="wfrd__card wfrd__card--error"
      [nzTitle]="errorTitle"
    >
      <ng-template #errorTitle>
        <div class="wfrd__card-head wfrd__card-head--error">
          <i nz-icon nzType="exclamation-circle"></i>
          Error Details
        </div>
      </ng-template>

      <div class="wfrd__error">
        <div
          *ngIf="errorPresentation.badgeLabel"
          class="wfrd__field"
          style="flex-wrap: wrap"
        >
          <nz-tag
            [nzColor]="
              errorPresentation.category === 'internal'
                ? 'blue'
                : errorPresentation.category === 'adapter'
                ? 'orange'
                : 'red'
            "
          >
            {{ errorPresentation.badgeLabel }}
          </nz-tag>
          <span
            *ngIf="errorPresentation.badgeSubLabel"
            style="opacity: 0.6; font-size: 0.85em"
          >
            {{ errorPresentation.badgeSubLabel }}
          </span>
        </div>

        <nz-descriptions
          *ngIf="errorPresentation.rows.length"
          nzBordered
          [nzColumn]="1"
        >
          <nz-descriptions-item
            *ngFor="let row of errorPresentation.rows"
            [nzTitle]="row.label"
          >
            <span class="wfrd__pre">{{ row.value }}</span>
          </nz-descriptions-item>
        </nz-descriptions>

        <p *ngIf="errorPresentation.fallbackText" class="wfrd__pre">
          {{ errorPresentation.fallbackText }}
        </p>

        <nz-collapse *ngIf="errorPresentation.technicalRaw" nzGhost>
          <nz-collapse-panel nzHeader="Technical details" [nzActive]="false">
            <pre class="wfrd__raw">{{ errorPresentation.technicalRaw }}</pre>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
    </nz-card>

    <!-- Payload -->
    <nz-card *ngIf="showRawJson" class="wfrd__card" [nzTitle]="payloadTitle">
      <ng-template #payloadTitle>
        <div class="wfrd__card-head">
          <i nz-icon nzType="code"></i>
          Workflow Payload
        </div>
      </ng-template>
      <nz-collapse nzGhost>
        <nz-collapse-panel nzHeader="Payload body (JSON)" [nzActive]="false">
          <div class="wfrd__json">
            <lite-json-editor [disabled]="true" [ngModel]="run.payload" />
          </div>
        </nz-collapse-panel>
      </nz-collapse>
    </nz-card>

    <!-- Snapshot -->
    <nz-card class="wfrd__card" [nzTitle]="snapshotTitle">
      <ng-template #snapshotTitle>
        <div class="wfrd__card-head">
          <i nz-icon nzType="deployment-unit"></i>
          Workflow Snapshot
        </div>
      </ng-template>

      <div class="wfrd__snapshot">
        <nz-descriptions
          *ngIf="
            snapshotPresentation.name || snapshotPresentation.triggerEvent
          "
          nzBordered
          [nzColumn]="1"
        >
          <nz-descriptions-item
            *ngIf="snapshotPresentation.name"
            nzTitle="Workflow"
          >
            {{ snapshotPresentation.name }}
          </nz-descriptions-item>
          <nz-descriptions-item
            *ngIf="snapshotPresentation.triggerEvent"
            nzTitle="Trigger"
          >
            <nz-tag class="wfrd__chip">{{
              snapshotPresentation.triggerEvent
            }}</nz-tag>
          </nz-descriptions-item>
        </nz-descriptions>

        <div
          *ngIf="
            snapshotPresentation.executed.length ||
            snapshotPresentation.pending.length
          "
          class="workflow-run-execution"
        >
          <h4 class="workflow-run-execution__heading">Execution</h4>
          <nz-timeline class="workflow-run-execution__timeline">
            <nz-timeline-item
              *ngFor="let step of snapshotPresentation.executed"
              nzColor="green"
            >
              <div class="wfrd__step">
                <div class="wfrd__step-head">
                  <nz-tag nzColor="green">{{ step.typeLabel }}</nz-tag>
                  <span class="wfrd__step-title">{{ step.title }}</span>
                </div>

                <nz-descriptions
                  *ngIf="step.contextRows.length"
                  nzSize="small"
                  [nzColumn]="1"
                  class="wfrd__step-ctx"
                >
                  <nz-descriptions-item
                    *ngFor="let row of step.contextRows"
                    [nzTitle]="row.label"
                  >
                    <code class="wfrd__code">{{ row.value }}</code>
                  </nz-descriptions-item>
                </nz-descriptions>

                <p *ngIf="step.resultSummary" class="wfrd__step-result">
                  <span class="wfrd__step-result-label">Result:</span>
                  {{ step.resultSummary }}
                </p>

                <nz-collapse *ngIf="step.hasResultObject" nzGhost>
                  <nz-collapse-panel nzHeader="Full result" [nzActive]="false">
                    <pre class="wfrd__raw wfrd__raw--scroll">{{
                      step.resultDetail
                    }}</pre>
                  </nz-collapse-panel>
                </nz-collapse>
              </div>
            </nz-timeline-item>

            <nz-timeline-item
              *ngFor="
                let step of snapshotPresentation.pending;
                let first = first
              "
              [nzColor]="run.status === 'failed' && first ? 'red' : 'gray'"
            >
              <div class="wfrd__step">
                <div class="wfrd__step-head">
                  <nz-tag
                    [nzColor]="
                      run.status === 'failed' && first ? 'error' : 'default'
                    "
                    >{{ step.typeLabel }}</nz-tag
                  >
                  <span class="wfrd__step-title">{{ step.title }}</span>
                  <span
                    *ngIf="run.status === 'failed' && first"
                    class="wfrd__step-failed"
                    >({{ snapshotPresentation.pendingLabel }})</span
                  >
                </div>

                <nz-descriptions
                  *ngIf="step.contextRows.length"
                  nzSize="small"
                  [nzColumn]="1"
                  class="wfrd__step-ctx"
                >
                  <nz-descriptions-item
                    *ngFor="let row of step.contextRows"
                    [nzTitle]="row.label"
                  >
                    <code class="wfrd__code">{{ row.value }}</code>
                  </nz-descriptions-item>
                </nz-descriptions>
              </div>
            </nz-timeline-item>
          </nz-timeline>
        </div>

        <nz-collapse *ngIf="showRawJson" nzGhost>
          <nz-collapse-panel nzHeader="Raw snapshot (JSON)" [nzActive]="false">
            <div class="wfrd__json">
              <lite-json-editor [disabled]="true" [ngModel]="run.snapshot" />
            </div>
          </nz-collapse-panel>
        </nz-collapse>
      </div>
    </nz-card>
  </div>
</ng-container>
